export default "__VITE_ASSET__2C$XfkKx__"